import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=d16784ec&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=d16784ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16784ec",
  null
  
)

export default component.exports